import type { FaireProductEntity } from "../../entity_types/product";

export const p_cx8zawrjxa: FaireProductEntity = {
  token: "p_cx8zawrjxa",
  type: "product",
  name: "Streetlevel Craft Instant Coffee",
  brandToken: "b_d3mdkn2j3h",
  brandName: "Verve Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/17e022b7d7b4a0639a9af2f6795d28bb643ae353d03cbc2e3832ae9f96527705.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0da3bb07d49074f90bd47a4b9b8f390826778a2400b32d911406c15cea266d94.jpeg"
  ],
  priceDollars: 10,
  description: "Notes of ripe red apple and zesty citrus are balanced by a honeycomb sweetness in this approachable fan favorite.\n\nAmazing things come in tiny packages. Verve Craft Instant Coffee is hand-roasted, small-batch brewed and preserved for your adventures. Ready to be brewed wherever and whenever. A week’s worth of premium coffee in your pocket.\n\nAdd one packet of Verve Craft Instant Coffee into your mug along with 10 ounces of hot or cold liquid (water, milk, or milk alternative), stir, and drink up.\n\nMakes 6 cups of coffee.\n\n𝐂𝐨𝐟𝐟𝐞𝐞 𝐃𝐞𝐭𝐚𝐢𝐥𝐬\n𝐂𝐨𝐮𝐧𝐭𝐫𝐲\nHonduras, Guatemala, Colombia\n𝐓𝐚𝐬𝐭𝐢𝐧𝐠 𝐍𝐨𝐭𝐞𝐬\nClementine, Red Apple, Honeycomb\n𝐏𝐫𝐨𝐝𝐮𝐜𝐞𝐫\nVarious Smallholding Farmers\n𝐏𝐫𝐨𝐜𝐞𝐬𝐬\nWashed\n𝐄𝐥𝐞𝐯𝐚𝐭𝐢𝐨𝐧\n1,500 - 2,000 Meters\n𝐇𝐚𝐫𝐯𝐞𝐬𝐭\nNovember - May",
  tags: [],
  msrpDollars: 16.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:49.745Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
